import axios from 'axios'
import dayjs from 'dayjs'
import { servicesAPI } from 'supporticon/utils/client'

const client = axios.create({
  baseURL: `https://dataapi.justgiving.com/${process.env.JG_DATA_API_KEY}`,
  headers: { accept: 'application/json' }
})

export const authenticateUser = (charityId, token) =>
  servicesAPI.post(
    `/v1/justgiving/reports/${charityId}/authenticate`,
    {},
    { headers: { Authorization: `Basic ${token}` } }
  )

export const fetchFundraiserData = (
  charityId,
  eventId,
  campaignGuid,
  startDate,
  endDate,
  token
) => {
  const end = endDate || dayjs().format('YYYY-MM-DD')
  const start = startDate || dayjs(end).subtract(1, 'month').format('YYYY-MM-DD')
  const urlPath = eventId ? `${charityId}/events/${eventId}` : charityId

  return client.get(`/v1/charity/${urlPath}/pages/created/${start};${end}`, {
    params: { campaignGuid },
    headers: { Authorization: `Basic ${token}` }
  })
    .then(response => response.data)
}
